import React from "react";

const CandidateList = ({ image, name, designation }) => {
    return (
        <div className="flex items-center">
            {image && (
                <img src={image} alt={name} className="w-5 h-5 rounded-full object-cover" />
            )}
            <div className="ml-4">
                <div className="font-semibold">{name}</div>
                <div className="text-sm text-gray-600">{designation}</div>
            </div>
        </div>
    );
};

export default CandidateList;
